<app-confirmation-dialog
  layout="start"
  [title]="
    itemType() === 'bundle'
      ? isArabic()
        ? 'إسقاط كل المنتجات من الباقة'
        : 'Drop All Products From Bundle'
      : isArabic()
        ? 'إسقاط كل المنتجات من العرض'
        : 'Drop All Products From Offer'
  "
  [description]="
    itemType() === 'bundle'
      ? isArabic()
        ? 'هل أنت متأكد من إسقاط باقي المنتجات في هذه الباقة من هذا الطلب؟'
        : 'Are you sure you want to drop the remaining products in this bundle from this order?'
      : isArabic()
        ? 'هل أنت متأكد من إسقاط باقي المنتجات في هذا العرض من هذا الطلب؟'
        : 'Are you sure you want to drop the remaining products in this offer from this order?'
  "
  [confirmContent]="isArabic() ? 'تأكيد' : 'Confirm'"
  [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
  [isLoading]="isLoading()"
  (onSubmit)="onSubmit()"
  (onCancel)="onCancel()" />
